// ==============================
//* PRODUCT PAGE VISUALS
//
//? This file manages the product page visuals elements.
// ==============================

$(() => {
    const $slider = $(".product-visuals__container.slider");
    const $sliderNav = $(".product-visuals__nav-container.slider-nav");
    const $sliderPager = $(".slick-pager");
    let $productVisuals = $(".js-zoom");
    let resizeTimeout = false;

    /**
     * Resize Listener
     */
    $(window).on("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(initSlider, 300);
    });

    /**
     * Listener to update the Slider pager
     */
    $slider.on("init reInit afterChange", function (event, slick, currentSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $sliderPager.text(i + "/" + slick.slideCount);
    });

    /**
     * Init the zoom feature on each visual
     * @param {JQuery} productVisuals - DOM element, usually the div.js-zoom element
     */
    function initZoom(productVisuals) {
        productVisuals.each(function () {
            $(this).append("<div class=\"js-zoom-in\"></div>");
            $(this).children(".js-zoom-in").css({ "background-image": "url(" + $(this).find("img").data("src") + ")" });
        });

        zoomListener(productVisuals);
    }

    /**
     * Listen to mouseover on each visuals and update zoom
     * @param {JQuery} productVisuals - DOM element, usually the div.js-zoom element
     */
    function zoomListener(productVisuals) {
        productVisuals
            .on("mouseover", function () {
                $(this).children(".js-zoom-in").css({ transform: "scale(" + $slider.attr("data-scale") + ")" });
            })
            .on("mouseout", function () {
                $(this).children(".js-zoom-in").css({ transform: "scale(1)" });
            })
            .on("mousemove", function (e) {
                $(this).children(".js-zoom-in").css({ "transform-origin": ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + "% " + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + "%" });
            });
    }

    /**
     * Slider initialization
     */
    function initSlider() {
        if ($slider.children().length > 1) {
            if (!$slider.hasClass("slick-initialized")) {
                // Init the main slider
                $slider.slick({
                    infinite: true,
                    slidesToShow: 1,
                    dots: false,
                    arrows: false,
                    asNavFor: ".product-visuals__nav-container.slider-nav",
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                dots: true,
                                arrows: false
                            }
                        }
                    ]
                });

                // Init the navigation slider
                $sliderNav.slick({
                    slidesToShow: 10,
                    slidesToScroll: 1,
                    asNavFor: ".product-visuals__container.slider",
                    dots: false,
                    centerMode: true,
                    focusOnSelect: true,
                    vertical: true,
                    arrows: false
                });
            }
        }
    }

    /**
     * Slider rebuilt
     */
    function rebuildSlider() {
        if ($slider.children().length > 1) {
            if ($slider.hasClass("slick-initialized")) {
                $slider.slick("unslick");
                $slider.find("div[id^=\"slick-\"]").remove();

                $slider.slick({
                    infinite: true,
                    slidesToShow: 1,
                    dots: false,
                    arrows: false,
                    asNavFor: ".product-visuals__nav-container.slider-nav",
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                dots: true,
                                arrows: false
                            }
                        }
                    ]
                });

                $sliderNav.slick({
                    slidesToShow: 10,
                    slidesToScroll: 1,
                    asNavFor: ".product-visuals__container.slider",
                    dots: false,
                    centerMode: true,
                    focusOnSelect: true,
                    vertical: true,
                    arrows: false
                });
            }
        } else {
            $sliderPager.empty();
        }
    }

    const $sizeSelector = $(".select-size");

    const productVisualsReady = (callback) => {
        const sliderVisualsIntervalChecker = setInterval(() => {
            if ($(".product-visuals__container > .product-visuals__item").length) {
                clearInterval(sliderVisualsIntervalChecker);
                $(".product-visuals__container").css("visibility", "visible");
                callback();
            }
        }, 100);
    };

    $sizeSelector.on("change", () => {
        $(".product-visuals__container").css("visibility", "hidden");
        productVisualsReady(rebuildSlider);
    });

    initZoom($productVisuals);

    /**
     * Image Zoom Modal functionality
     */
    document.querySelectorAll(".js-zoom-toggle").forEach(button => {
        button.addEventListener("click", function () {
            const imageUrl = this.getAttribute("data-image-url");
            document.querySelector(".js-modal-image").setAttribute("src", imageUrl);
        });
    });

    initSlider();
});
